export default function ThunderSvgIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="6"
      height="9"
      viewBox="0 0 6 9"
      className="md:w-2 md:h-3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.01119 0L0 4.91645L2.67767 4.89861L1.70639 9L6 3.48824H3.33513L4.01119 0Z"
        fill="#131313"
      />
    </svg>
  );
}
